import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./Notification.css";

class Notification extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { show, content, cancelHandler, successHandler } = this.props;
    const {
      type,
      messagetype,
      button,
      message,
      icon,
      title,
      button2,
      endMessage,
      classNameButton1,
      classNameButton2,
    } = content;
    return (
      <div
        className="container-fluid modal-container"
        style={{ zIndex: "9999" }}
      >
        <div className="modal-content">
          <div className="row">
            <div className="col-2 col-md-2">
              <i className={`notification-icon fa ${icon}`}></i>
            </div>
            <div className="col-10 col-md-6">
              <p className="session-end-text">{title}</p>
              <p>
                {message}{" "}
                {messagetype && (
                  <span
                    className={`message-type ${
                      type === "success" ? "success" : "failure"
                    }`}
                  >
                    {messagetype}
                  </span>
                )}{" "}
                {endMessage}
              </p>
            </div>
            <div className="col-12 col-md-4 button-spacing">
              {button2 && (
                <Button
                  className={`time-extension-button ${classNameButton1}`}
                  onClick={() => successHandler()}
                >
                  Yes
                </Button>
              )}
              <Button
                className={`time-extension-button mt-2 ${classNameButton2}`}
                onClick={() => cancelHandler()}
              >
                {button2 ? "No" : "Okay"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Notification;
